export const fontMainSize: number = 22;
export const fontSecondarySize: number = 16;
export const fontSmallSize: number = 12;
export const forecastLogoWidth: number = 30;
export const lineInterval: number = 10;
export const padding: number = 10;
export const fontNormal = {
  fontName: 'Roobert-Regular',
  fontStyle: 'normal',
};
export const fontBold = {
  fontName: 'Roobert-SemiBold',
  fontStyle: 'bold',
};
